import { render, staticRenderFns } from "./SettingHeader.vue?vue&type=template&id=c6fc32b2"
import script from "./SettingHeader.vue?vue&type=script&lang=js"
export * from "./SettingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports